export default "__VITE_ASSET__Cri0WwS9__"